import React, { useEffect, useState }  from 'react'

import { loadMasterAdmin } from '../core/services/admin';
import { ShareHelper } from '../helpers'
import { Avatar, Location } from './index.jsx'
import { WhatsAppIcon } from './ContactLinks'
import { Icon, IconButton } from './ui'

const UserCard = ({ user, hideName = false, className = '', mailSubject = '', mailBody = '', whatsAppMessage = '' }) => {
  const [masterAdmin, setMasterAdmin] = useState(null);
  const hasUserProp = !!user;

  if (!user) {
    user = masterAdmin;
  }

  useEffect(() => {
    // Only fall back to the (DAO) master admin when no user was supplied. When a
    // listing's own seller is passed, don't fetch /api/master-admin — it's the
    // wrong contact for non-DAO stores (and avoids that public endpoint).
    if (!hasUserProp) {
      loadMasterAdmin(setMasterAdmin);
    }
  }, [hasUserProp]);

  if (!user) {
    return null;
  }

  const onWhatsAppClick = (e) => {
    e.preventDefault()
    ShareHelper.whatsapp(whatsAppMessage, user.phone)
  }

  const mailHref = `mailto:${encodeURIComponent(user.email)}?subject=${encodeURIComponent(mailSubject)}&body=${encodeURIComponent(mailBody)}`

  const store = user.store

  return (
      <div className={`card user ${className}`}>
          <div className="d-flex justify-content-between">
              <div className="d-flex">
                  {!hideName && (
                      <Avatar fileId={user.avatar_file_id} user={user} />
                  )}

                  <div>
                      <div className="user-name" style={{ paddingLeft: "3px"}}>
                          {!hideName && (
                              <>{user.first_name} {user.last_name}</>
                          )}
                          <div className="d-flex mt-1">
                              <Location store={store} />
                          </div>
                      </div>
                  </div>
              </div>

              <div className="user-card__contact d-flex">
                  <IconButton size="lg" label="Email" href={mailHref} className="align-self-center" data-btn="seller-email">
                      <Icon name="Mail" size="md" />
                  </IconButton>
                  <IconButton size="lg" label="WhatsApp" onClick={onWhatsAppClick} className="align-self-center" data-btn="seller-whatsapp">
                      <WhatsAppIcon />
                  </IconButton>
              </div>
          </div>
      </div>
  )
};

export default UserCard
